import { toast } from "react-toastify";

export const printMergedSummary = (summaryData, reciptDetails, userID) => {
  const receiptUserId = String(userID || "").trim();

  if (!summaryData || !summaryData.response) {
    console.error("No data");
    return;
  }


  const list = summaryData.response;

  //  WHATSAPP DATA (CALCULATED)
  const whatsappOrders = list.filter((o) => o.platform === "W");

  const whatsappData = {
    totalUPICollectedAmount: whatsappOrders
      .filter((o) => o.payment_mode?.toLowerCase() === "upi")
      .reduce((s, o) => s + Number(o.totalOrderPrice || 0), 0),

    totalDeliveryCharges: whatsappOrders.reduce(
      (s, o) => s + Number(o.delivery_fee || 0),
      0,
    ),

    totalPlatformCharges: whatsappOrders.reduce(
      (s, o) => s + Number(o.charges || 0) + Number(o.gst || 0),
      0,
    ),

    totalSummaryAmount: whatsappOrders.reduce(
      (s, o) => s + Number(o.totalOrderPrice || 0),
      0,
    ),

    takeways: whatsappOrders.filter((o) => o.orderType === "takeaway").length,
    homeDeliveries: whatsappOrders.filter(
      (o) => o.orderType === "home_delivery",
    ).length,
  };

  //  POS DATA
  const posOrders = list.filter((o) => o.platform !== "W");

  const posData = {
    totalUPICollectedAmount: posOrders
      .filter((o) => o.payment_mode?.toLowerCase() === "upi")
      .reduce((s, o) => s + Number(o.totalOrderPrice || 0), 0),

    totalCardCollectedAmount: posOrders
      .filter((o) => o.payment_mode?.toLowerCase() === "card")
      .reduce((s, o) => s + Number(o.totalOrderPrice || 0), 0),

    totalDeliveryCharges: posOrders.reduce(
      (s, o) => s + Number(o.delivery_fee || 0),
      0,
    ),

    totalPlatformCharges: posOrders.reduce(
      (s, o) => s + Number(o.platform_charge || 0),
      0,
    ),

    totalMessageCharges: 0,

    totalSummaryAmount: posOrders.reduce(
      (s, o) => s + Number(o.totalOrderPrice || 0),
      0,
    ),

    takeways: posOrders.filter((o) => o.orderType === "takeaway").length,
    dinnings: posOrders.filter((o) => o.orderType === "dining").length,
    homeDeliveries: posOrders.filter((o) => o.orderType === "home_delivery")
      .length,
    carOrders: posOrders.filter((o) => o.orderType === "car_order").length,
  };

  //  FINAL DATA
  const finalData = {
    totalUPICollectedAmount: list
      .filter((o) => o.payment_mode?.toLowerCase() === "upi")
      .reduce((s, o) => s + Number(o.totalOrderPrice || 0), 0),

    totalDeliveryCharges: list.reduce(
      (s, o) => s + Number(o.delivery_fee || 0),
      0,
    ),

    totalPlatformCharges: list.reduce(
      (s, o) => s + Number(o.charges || 0) + Number(o.gst || 0),
      0,
    ),

    totalMessageCharges: 0,

    totalSummaryAmount: list.reduce(
      (s, o) => s + Number(o.totalOrderPrice || 0),
      0,
    ),

    takeways: list.filter((o) => o.orderType === "takeaway").length,
    homeDeliveries: list.filter((o) => o.orderType === "home_delivery").length,
  };

  //   whatsapp summary

  const printWhatsappBlock = (section) => `
  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Total UPI Collected:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalUPICollectedAmount) || 0).toFixed(2)}</span>
  </div>
  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Total Delivery Charges:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalDeliveryCharges) || 0).toFixed(2)}</span>
  </div>
  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Total Platform Fee:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalPlatformCharges) || 0).toFixed(2)}</span>
  </div>
  <div style="display:flex; justify-content:space-between; padding: 0 4px; font-weight:600;">
    <span class="textSizeMid">Total Order Amount:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalSummaryAmount) || 0).toFixed(2)}</span>
  </div>
  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Takeaways:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">${section.takeways || 0}</span>
  </div>
  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Home Deliveries:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">${section.homeDeliveries || 0}</span>
  </div>
`;

  const printSummaryBlock = (section) => `
  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Total Cash Collected:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalCashCollectedAmount) || 0).toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Total UPI Collected:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalUPICollectedAmount) || 0).toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Total Delivery Charges:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalDeliveryCharges) || 0).toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Total Platform Fee:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalPlatformCharges) || 0).toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between; padding: 0 4px; font-weight:600;">
    <span class="textSizeMid">Total Order Amount:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">Rs. ${(Number(section.totalSummaryAmount) || 0).toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Takeaways:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">${section.takeways || 0}</span>
  </div>

  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Home Deliveries:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">${section.homeDeliveries || 0}</span>
  </div>

  <div style="display:flex; justify-content:space-between; padding: 0 4px;">
    <span class="textSizeMid">Dinings:</span>
    <span class="textSizeMid" style="text-align:right; white-space:nowrap; padding-left:4px;">${section.dinnings || 0}</span>
  </div>
`;

  const html = `
  <html>
  <head>
    <style>
      body { font-family: Arial; }
      .center { text-align:center; }
      .header, .header2, .headerTable, .headerTotal, .headerEnd {
        border-bottom:1px dashed #000;
        padding:2px 0;
      }
      .textSizeLarge { font-size:14px; font-weight:600; }
      .textSizeMid { font-size:10px; }
      table { width:100%; border-collapse:collapse; }
      th, td { font-size:9px; padding:2px; text-align:center; }
    </style>
  </head>

  <body>

    <div class="header center">
      <p class="textSizeLarge" style="margin:0;">${reciptDetails.business_name}</p>
      <p class="textSizeMid" style="margin:0;">${reciptDetails.address}</p>
     <p class="textSizeMid" style="margin:0;">PH: ${reciptDetails.phone_no}</p>
<p class="textSizeMid" style="margin:0;">GST NO: ${reciptDetails.gst}</p>
${
  receiptUserId === "A1222"
    ? `
      <p class="textSizeMid">
        FSSAI NO:
        12724052000539
      </p>
    `
    : ""
}
      <p class="textSizeLarge">** MERGED SUMMARY REPORT **</p>
    </div>

    <div class="header2">
      <p class="textSizeMid" style="text-align:center;">
        Date : ${summaryData.fromDate}
      </p>
    </div>

    <div class="headerTable">
      <table>
        <thead>
          <tr>
            <th>O.ID</th>
            <th>BILL</th>
            <th>TYP</th>
            <th>MOD</th>
             <th>SRC</th>
            <th>AMT</th>
          </tr>
        </thead>
        <tbody>
          ${[...list]
            .reverse()
            .map(
              (o) => `
            <tr>
              <td>${o.daily_order_id}</td>
              <td>${o.orderid}</td>
              <td>${o.orderType === "takeaway" ? "Tkwy" : "H.Del"}</td>
              <td>${o.payment_mode}</td>
               <td>${o.platform}</td>
              <td style="font-weight:600;">
                ${Number(o.totalOrderPrice).toFixed(2)}
              </td>
            </tr>
          `,
            )
            .join("")}
        </tbody>
      </table>
    </div>

   <div style="border-bottom:1px dashed #000; padding:1px 0;">
     <p class="textSizeLarge center" style="margin:4px 0;">WhatsApp Summary</p>
      ${printWhatsappBlock(whatsappData)}
    </div>

<div style="border-bottom:1px dashed #000; padding:1px 0;">
  <p class="textSizeLarge center" style="margin:0;">POS Summary</p>
  ${
    summaryData.pos && Object.keys(summaryData.pos).length > 0
      ? printSummaryBlock(summaryData.pos)
      : printSummaryBlock(posData)
  }
</div>

   <div style="border-bottom:1px dashed #000; padding:1px 0;">
  <p class="textSizeLarge center" style="margin:4px 0;">Final Summary</p>
  ${printSummaryBlock(finalData)}
</div>

 <div class="headerEnd center">
  <p class="textSizeMid" style="margin: 4px 0;">Order Type Legends:</p>
  <p class="textSizeMid" style="margin: 4px 0;">Tkwy = Takeaway | H.Del = Home Delivery | Dine = Dining</p>
  <p class="textSizeMid" style="margin: 4px 0;">** END OF SUMMARY REPORT **</p>
</div>

  </body>
  </html>
  `;

  const win = window.open("", "_blank");
  if (!win) {
    toast.error("Popup blocked");
    return;
  }

  win.document.write(html);
  win.document.close();

  setTimeout(() => {
    win.print();
    win.close();
  }, 300);
};
